import { Chip, Theme, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Agency, AgencyCategory, AgencyCode, AreaCode, RegionCode } from "../../../reducers/states/agency";
import { GetAgency } from "../../../reducers/states/agency/agencies";
import { getWspLabel } from "../../../reducers/states/agency/wsp";

const useStyles = makeStyles((theme: Theme) => ({
  chipWsp: {
    backgroundColor: theme.agency.WSP,
    color: "white",
  },
  chipKcm: {
    backgroundColor: theme.agency.KCM,
    color: "white",
  },
  chipFire: {
    backgroundColor: theme.category.Fire,
    color: "white",
  },
  chipLawenforcement: {
    backgroundColor: theme.category.LawEnforcement,
    color: "white",
  },
  chipNeutral: {
    backgroundColor: theme.agency.Neutral,
    color: "black",
  },
  chipClosed: {
    backgroundColor: theme.marker.ClosedDispatchEventIFD,
    color: "white",
  },
  listItem: {
    flex: "1 1 55%",
  },
  removeButton: {
    color: theme.agency.SFD,
    padding: "3px",
    "margin-left": "10px",
  },
}));

interface ChipProps {
  props: {
    agency: AgencyCode;
    area?: AreaCode;
    region?: RegionCode;
    isClosed?: boolean;
  };
}

export const AgencyChip = ({ props }: ChipProps) => {
  const classes = useStyles();

  const getClassName = (agencyObj: Agency) => {
    switch (props.agency) {
      case AgencyCode.WSP:
        return classes.chipWsp;
      case AgencyCode.KCM:
        return classes.chipKcm;
    }

    switch (agencyObj.category) {
      case AgencyCategory.Fire:
        return classes.chipFire;
      case AgencyCategory.LawEnforcement:
        return classes.chipLawenforcement;
    }

    return classes.chipNeutral;
  }

  if (props.agency === "") {
    return <div>{props.agency}</div>;
  }

  const agencyObj = GetAgency(props.agency);
  const agencyName = agencyObj?.name || props.agency;
  const tooltip =  props.agency === AgencyCode.WSP ? `${agencyName}, ${(getWspLabel(props.area) as string)}` : agencyObj?.name;  
  const className = agencyObj ? getClassName(agencyObj) : classes.chipNeutral;

  return (
    <Tooltip title={tooltip}>
      <Chip label={agencyObj?.id} className={props.isClosed ? classes.chipClosed : className} sx={{ minWidth: "62px" }}/>
    </Tooltip>
  )  
};
